export default class Config {
  // static baseUrl: string = 'http://localhost:3000/api/v1'
  // static baseUrlV2: string = 'http://localhost:3000/api/v2'
  static baseUrl: string = 'https://leukapi-test.laiterieduberger.sn/api/v1'
  static baseUrlV2: string = 'https://leukapi-test.laiterieduberger.sn/api/v2'
  static showQrCode: boolean = true;
}
